import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export function imgUrl(u) {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
}

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  if (!e?.response) return "Network problem. Please check your connection and try again.";
  const d = e.response.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((x) => String(x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ") || fallback;
  }
  return d.msg || fallback;
}
